import { STATIC_BAR_CHART_OPTION } from '../constants/echarts';

export const getBarChartStaticOption = (cfg: { primaryKey: string; dimensions: string[] }) => {
  const { primaryKey, dimensions } = cfg || {};

  return {
    ...STATIC_BAR_CHART_OPTION,
    dataset: {
      ...STATIC_BAR_CHART_OPTION.dataset,
      dimension: [primaryKey, ...dimensions],
    },
  };
};

const getRanksData = (data: any, dimensions?: string[]): { [key: string]: number } => {
  if (!Array.isArray(dimensions)) return {};
  const ranksData = data?.source_metric_list || [];

  return dimensions.reduce((cur, next) => {
    if (!next) return cur;
    const nextRank = ranksData?.find((rankData: any) => rankData?.metric === next);
    const nextRankValue = nextRank?.value;
    return { ...cur, [next]: nextRankValue };
  }, {});
};

export const getBarChartSourceData = (
  data: any[],
  cfg: {
    primaryKey: string;
    dimensions?: string[];
  },
): any[] => {
  if (!Array.isArray(data)) return [];
  const { primaryKey, dimensions } = cfg || {};
  return data.map((item) => {
    const ranksData = getRanksData(item, dimensions);
    return {
      [primaryKey]: item?.[primaryKey],
      ...ranksData,
    };
  });
};
